import { render, staticRenderFns } from "./orderMain.vue?vue&type=template&id=c560f7d8&scoped=true"
import script from "./orderMain.vue?vue&type=script&lang=js"
export * from "./orderMain.vue?vue&type=script&lang=js"
import style0 from "@/pages/orderBox/saleOrder/style/popDialog.scss?vue&type=style&index=0&lang=scss&external"
import style1 from "../style/orderMain.scss?vue&type=style&index=1&id=c560f7d8&lang=scss&scoped=true&external"
import style2 from "./orderMain.vue?vue&type=style&index=2&id=c560f7d8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c560f7d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c560f7d8')) {
      api.createRecord('c560f7d8', component.options)
    } else {
      api.reload('c560f7d8', component.options)
    }
    module.hot.accept("./orderMain.vue?vue&type=template&id=c560f7d8&scoped=true", function () {
      api.rerender('c560f7d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/saleOrder/components/orderMain.vue"
export default component.exports